const _ = require("lodash");
const PT = require("prop-types");
const React = require("react");
const createReactClass = require("create-react-class");
const withAnimateRef = require("../hoc/withAnimateRef");
const withVaultDispatch = require("../hoc/withVaultDispatch");
const withContainerDims = require("../hoc/withContainerDims");
const withSetURL = require("../hoc/withSetURL");
const ScrollArea = require("./ScrollArea");
const ModalClose = require("./ModalClose");
const withDelayedRender = require("../hoc/withDelayedRender");
const TrainerCore = require("../../../shared/TrainerCore");
const URLMake = require("../../../shared/URLMake");
const GradeChapter = require("../../../shared/GradeChapter");
const AT = require("../vault/ActionTypes");

const WebAnimations = require("../util/WebAnimations");
const Bundles = require("../Bundles");
const Copy = require("../util/TutorialCopy");
const Sounds = require("../util/Sounds");
const AssetsUtil = require("../util/AssetsUtil");
const OpsUser = require("../vault/OpsUser");
const OpsBlock = require("../vault/OpsBlock");
const OpsPage = require("../vault/OpsPage");
const OpsTutorial = require("../vault/OpsTutorial");
const BugReportButton = require("./BugReportButton");
const TutorialModalButton = require("./TutorialModalButton");
const MessageBubble = require("./MessageBubble");
const Link = require("./Link");
const dbDemoData = require("../../../shared/data/dbDemoData.json");
const makeLabCopyFunc = Copy.makeLabCopyFunc;

const styles = require("./styles/TutorialModal.css");

// When this modal opens on pages with this name, the music stops. When the
// modal closes, the music given by the value here starts back up. TODO: there
// should be a central table mapping pages to played music so that we aren't
// duplicating here.
const musicStopTable = {
	"beastbuilder.main": "general-background",
};

const augment = function(Component) {
	Component = withVaultDispatch(Component);
	Component = withAnimateRef(Component);
	Component = withContainerDims(Component);
	Component = withSetURL(Component);
	// This component contains animations in componentDidMount, so we need to
	// delay rendering via a higher-order component.
	Component = withDelayedRender(Component);
	return Component;
};
module.exports = augment(
	createReactClass({
		displayName: "TutorialModal",

		propTypes: {
			className: PT.string,
			page: PT.object.isRequired,
			user: PT.object.isRequired,
			block: PT.object,
			labBlock: PT.object,
			theaterSet: PT.object,
			onClose: PT.func,
			demo: PT.bool,
			forLab: PT.bool,
			labType: PT.number,
			closeOnEsc: PT.bool,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
			animateRef: PT.func.isRequired,
			containerDims: PT.object.isRequired,
			setURL: PT.func.isRequired,
		},

		componentDidMount: function() {
			this.handleOpen();

			const pageName = _.get(this.props, "page.name", "");
			if (musicStopTable[pageName]) {
				Sounds.stopMusic();
			}

			// Add key listener for Escape key
			if (this.props.closeOnEsc) {
				document.addEventListener("keydown", this.handleKeyDown);
			}
		},

		componentWillUnmount: function() {
			const pageName = _.get(this.props, "page.name", "");
			if (musicStopTable[pageName]) {
				Sounds.playMusic(musicStopTable[pageName]);
			}

			// Remove key listener
			if (this.props.closeOnEsc && this.handleKeyDown) {
				document.removeEventListener("keydown", this.handleKeyDown);
			}
		},

		handleKeyDown: function(event) {
			if (event.key === "Escape") {
				this.handleClose();
			}
		},

		handleOpen: function() {
			this.modal.classList.remove(styles.hidden);
			this.props.animateRef(this.modal, WebAnimations.tutorialIn, {
				duration: 400,
				easing: "linear",
				iterations: 1,
			});
		},

		restartTutorial: function() {
			Sounds.playSound("button-click");
			this.props.dispatch({
				type: AT.STUDENT_TUTORIAL_UPDATE_PROGRESS_REQUEST,
				part: "beginStudentTutorial",
				step: "welcomeToBA",
				restart: true,
			});
			this.handleClose();
		},

		restartDemo: function() {
			Sounds.playSound("button-click");
			this.props.dispatch({
				type: AT.RESTART_DEMO,
			});
			this.props.setURL(URLMake.forDemoHome());
			this.handleClose();
		},

		handleClose: function() {
			this.props.animateRef(
				this.modal,
				WebAnimations.tutorialOut,
				{
					duration: 400,
					easing: "linear",
					iterations: 1,
				},
				() => {
					if (this.modal) {
						this.modal.classList.add(styles.hidden);
					}
					this.props.onClose && this.props.onClose();
				}
			);
		},

		render: function() {
			const {
				page,
				user,
				containerDims,
				block,
				labBlock,
				theaterSet,
				demo,
				forLab,
				labType,
			} = this.props;

			const userCanReportBugs = OpsUser.canReportBugs(user);
			const userCanPlay = OpsUser.hasKey(user, "trainer play");
			let button = null;
			if (demo) {
				button = (
					<TutorialModalButton
						onClick={this.restartDemo}
						className={styles.restartDemo}
						text={"Restart Demo"}
					/>
				);
			} else if (userCanPlay) {
				if (
					OpsPage.isHomeMain(this.props.page) &&
					OpsTutorial.isTutorialEnabled() &&
					OpsTutorial.shouldSeeTutorial(this.props.user)
				) {
					// Normally we would use OpsTutorial to get the progress, but it will return
					// "finished" if no data is present, and we need to know if no data is present here
					// to show the right text
					const hasDoneTutorialBefore = _.get(
						this.props.user,
						[
							"model",
							"eventsTriggered",
							"tutorials",
							"studentTutorial",
							"currentPart",
						],
						null
					);
					const restartText =
						(hasDoneTutorialBefore ? "Restart" : "Play") + " Student Tutorial";
					button = (
						<TutorialModalButton
							onClick={this.restartTutorial}
							className={styles.restartTutorial}
							text={restartText}
						/>
					);
				} else if (userCanReportBugs) {
					button = (
						<BugReportButton className={styles.bugReport} withText={true} />
					);
				}
			}
			const defaultPageForCopy = "home.main";

			let levelInfo, userInfo;
			if (demo) {
				levelInfo = {};
				userInfo = {
					user,
					avatar: dbDemoData.avatarModel,
					page,
					block,
					theaterSet,
					hasHomework: false,
				};
			} else {
				levelInfo = TrainerCore.getLevelXP(user.model.xp);
				userInfo = {
					level: levelInfo.currLevel,
					xp: levelInfo.currLevelXP,
					user,
					avatar: user.model.avatar,
					page,
					block,
					labBlock,
					theaterSet,
					hasHomework: user.model.showHomework,
				};
			}

			let copyFunc, copyData;
			if (forLab) {
				copyFunc = makeLabCopyFunc(labType); // make a function that's the copy for the lab type
			} else if (OpsBlock.isAnyTest(block)) {
				copyFunc = Copy["test"];
				const forHistory = page.name === "trainer.history";
				const result = forHistory
					? _.get(block, ["history", "allResults", 0])
					: _.get(block, "currentResult");
				const OpsResult = Bundles.requireOpt("trainer", "OpsResult");
				if (result && OpsResult) {
					const timeSinceStart = OpsResult.getTimeSinceStart(
						result,
						Date.now()
					);
					const forBookTest = OpsBlock.isBookTest(block);
					const testInfo = TrainerCore.getTestInfo(result, timeSinceStart);
					const chapterInfo = block.model.chapterID
						? GradeChapter.chapterIDToContext(block.model.chapterID)
						: {};
					const miscBlockName = block.model.miscBlockName;
					const submitRestrictions = TrainerCore.getTestSubmitRestrictions(
						testInfo
					);
					copyData = _.extend(testInfo, chapterInfo, {
						miscBlockName,
						forHistory,
						forBookTest,
						submitRestrictions,
					});
				}
			} else {
				copyFunc = Copy[page.name] || Copy[defaultPageForCopy];
			}
			const contentCopy = copyFunc(styles, userInfo, containerDims, copyData);
			/* the content displayed in the main area of the page */
			const content = (
				<ScrollArea areaClassName={styles.content} hasXScroll={false}>
					{contentCopy.content}
				</ScrollArea>
			);

			let mainClass = styles.main;
			if (this.props.className) {
				mainClass += " " + this.props.className;
			}

			return (
				<div className={mainClass} ref={c => (this.modal = c)}>
					<img
						className={styles.bg}
						src={AssetsUtil.getInstructionsModal("headmaster")}
					/>
					<img
						className={styles.beast}
						src={AssetsUtil.getBeastInstruction(
							"headmaster",
							_.get(block, "model.gradeNumber") || 3
						)}
					/>
					<div className={styles.contentBeast}>{content}</div>
					<div className={styles.title}>
						<img
							className={styles.question}
							src={AssetsUtil.getButton("help", "black")}
						/>
						Help
					</div>
					<div className={styles.report}>{button}</div>
					<div className={styles.privacyTerms}>
						<Link to={URLMake.forPrivacy()} isNewTab={true}>
							Privacy
						</Link>
						<div className={styles.dot} />
						<Link to={URLMake.forTerms()} isNewTab={true}>
							Terms
						</Link>
					</div>
					<MessageBubble
						styleType="headmaster"
						bubbleType="tutorial"
						message={contentCopy.title}
						canClose={false}
					/>
					<ModalClose
						onClick={() => {
							Sounds.playSound("whoosh");
							this.handleClose();
						}}
						extraClassName={styles.closeButton}
					/>
				</div>
			);
		},
	})
);
